import {
  selectElement,
  removeClass,
  addClass,
  stringFalseOrTrue,
  rangeFromZero,
  rangeFrom,
  addMultipleToCart,
  getDataFromForm,
  generateProductLinkId,
  moreThan,
  tempDisable
} from '//framemymirror.com/cdn/shop/t/73/assets/utils.js?v=77022512612261834451774541742'

import { MicroModal } from '//framemymirror.com/cdn/shop/t/73/assets/micromodal.min.js?v=123726146110716826381774541742' // Change default import to named import
import MultiAccordion from '//framemymirror.com/cdn/shop/t/73/assets/multiAccordion.js?v=115314358659109584261776785518' // es6 module

if (!customElements.get('frame-my-mirror-form')) {
  customElements.define(
    'frame-my-mirror-form',
    class FrameMyMirrorForm extends HTMLElement {
      constructor () {
        super()
        // Elements variables

        this.stepContainers = this.querySelectorAll('[data-accordion]')

        this.frameType = this.dataset?.formType

        this.footageSelectElements = this.querySelectorAll(
          '[data-frame-width-select],[data-frame-fractional-width-select], [data-frame-height-select],[data-frame-fractional-height-select]'
        )
        this.obstructionDistanceSelectElements = this.querySelectorAll(
          '[data-obstruction-top-select], [data-obstruction-right-select], [data-obstruction-bottom-select], [data-obstruction-left-select]'
        )
        this.clipAndBevelSelectElements = this.querySelectorAll(
          '[data-clip-amount-select],[data-is-beveled-select], [data-bevel-amount-select]'
        )

        this.mirrorTypeCheckboxes = this.querySelectorAll(
          '[data-mirror-type-checkbox]'
        )

        this.orderSummaryContainerElement = this.querySelector(
          '[data-order-summary-container]'
        )
        this.priceElements = document.querySelectorAll('[data-total-price]')
        this.nextButtonElements = this.querySelectorAll(
          '[data-action="nextAccordion"]'
        )
        this.previousButtonElements = this.querySelectorAll(
          '[data-action="lastAccordion"]'
        )
        this.form = this.querySelector('[data-main-product-form]')

        this.clipProductForm = this.querySelector('[data-clip-form]')

        this.feeProductForm = this.querySelector('[handling-fee-form]')

        const variantAffectingInputs = [
          this.footageSelectElements,
          this.obstructionDistanceSelectElements,
          this.mirrorTypeCheckboxes
        ]

        this.incompleteFieldsText = 'Please complete all fields before proceeding.'

        // Data tables for SKU
        this.linearFootageRanges = {
          '00-10': [...rangeFromZero(11)],
          '11-12': [11, 12],
          '13-14': [13, 14],
          '15-16': [15, 16],
          '17-18': [17, 18],
          '19-20': [19, 20],
          '21-22': [21, 22],
          '23-24': [23, 24],
          '25-26': [25, 26],
          '27-28': [27, 28],
          '29-30': [29, 30],
          '31-32': [31, 32],
          '33-34': [33, 34],
          '35-36': [35, 36],
          '37-38': [37, 38],
          '39-40': [39, 40]
        }

        this.hangRailValues = {
          '12HRW': [0, 30],
          '18HRW': [30, 37],
          '24HRW': [37, 42],
          '36HRW': [42, 54],
          '48HRW': [54, 66],
          '60HRW': [66, 90]
        }

        // New hangrail values based on height
        this.hangRailHeightValues = {
        '12HRH': [0, 30],
        '18HRH': [30, 37],
        '24HRH': [37, 42],
        '36HRH': [42, 54],
        '48HRH': [54, 66],
        '60HRH': [66, 90]
        }

        this.mirrorTypeValues = {
          Beveled: 'BV',
          Antiqued: 'AN',
          Standard: ''
        }

        //Functions called by text in HTML
        this.sourcingFunctions = {
          widthAndHeightSummary: this.widthAndHeightSummary,
          obstructionDimensionsSummary: this.obstructionDimensionsSummary,
          ClipsAndBevelSummary: this.ClipsAndBevelSummary,
          outerWidthAndHeightSummary: this.outerWidthAndHeightSummary,
          productVariantSummary: this.productVariantSummary
        }

        this.inputSourcingFunctions = {
          getWidthInputValue: this.getWidthInputValue,
          getHeightInputValue: this.getHeightInputValue,
          getTopInputValue: this.getTopInputValue,
          getRightInputValue: this.getRightInputValue,
          getBottomInputValue: this.getBottomInputValue,
          getLeftInputValue: this.getLeftInputValue,
          getFrameWidthInputValue: this.getFrameWidthInputValue,
          getFrameHeighthInputValue: this.getFrameHeighthInputValue,
          getBevelStateInputValue: this.getBevelStateInputValue,
          getBevelWidthInputValue: this.getBevelWidthInputValue,
          getCustomSku: this.getCustomSku
        }

        this.stepFunctions = {
          checkForFrameMyMirrorHandlingFees: this
            .checkForFrameMyMirrorHandlingFees,
          checkForFramedMirrorHandlingFees: this
            .checkForFramedMirrorHandlingFees,
          checkForFramedMirrorLengthImbalance: this
            .checkForFramedMirrorLengthImbalance
        }

        this.inputFunctions = {
          disableBevelStateSelect: this.disableBevelStateSelect
        }

        this.validateFunctions = { 
          validateStep: this.validateStep,
          validateNarrowFrame: this.validateNarrowFrame,
          validateOneTimePopup: this.validateOneTimePopup
        }

        this.alertFunctions = {
          triggerIncompleteInputAlert: this.triggerIncompleteInputAlert,
          triggerNarrowFrameModal: this.triggerNarrowFrameModal,
          triggerFrameMyMirrorHandlingFeesModal: this.triggerFrameMyMirrorHandlingFeesModal,
          triggerFramedMirrorHandlingFeesModal: this.triggerFramedMirrorHandlingFeesModal


        }

        //Start event handlers
        this.handlePageShow(this.stepContainers)
        this.handleNext(this.nextButtonElements)
        this.handlePrevious(this.previousButtonElements)
        this.initStepFunctions(this.stepContainers)
        this.handleDimensionInputs(...variantAffectingInputs)
        this.handleObstructionsInputs(...variantAffectingInputs)
        this.handleClipAndBevelInputs(this.clipAndBevelSelectElements)
        this.handleMirrorTypeSelect(...variantAffectingInputs)
        this.handleOrderSummaryGeneration(this.orderSummaryContainerElement)
        this.handleFormInputsGeneration(this.orderSummaryContainerElement)
        this.handleSubmit(this.form, this.clipProductForm, this.feeProductForm)

        this.initializeMicroModal()
        const multiAccordion = new MultiAccordion('[data-accordion-containers]')
      }

      initializeMicroModal() {
        document.addEventListener('DOMContentLoaded', () => {
          MicroModal.init({
            disableScroll: true, // Prevent background scrolling
            awaitCloseAnimation: true, // Wait for animation to complete before closing
            onShow: () => {
              document.body.style.overflow = 'hidden';
            },
            onClose: () => {
              document.body.style.overflow = '';
            }
          });
        });
      }

      /*Function organization:
            Event handling
            Middleware
            Getters (Getting values from the DOM or Data)
            Dom Changes
      */

      //EVENT AND ACTION HANDLERS

      handlePageShow(stepContainers) {
        window.addEventListener('pageshow', (event) => {
          setTimeout(() => {
            stepContainers.forEach( (stepContainer, index) => {
              if( this.getActiveStatus(stepContainer) && index !== 0 ) {
                this.closeAccordion(index + 1)
                this.openAccordion(1)
              }
            })
          }, 500)
        })
      }

      handleNext (nextButtonElements) {
        nextButtonElements.forEach(button => {
          button.addEventListener('click', () => {
            const functionNames = button.dataset.nextStepActions.split(',')
            functionNames &&
              functionNames.forEach(functionName => {
                if ((functionName === undefined) ||(functionName == '')) {
                  return
                }
                const isValid = this.validateFunctions[functionName](button)
                const alertFunction =  button.dataset.conditionNotMetAlert
                isValid
                  ? this.openNextAccordion(button)
                  : this.alertFunctions[alertFunction](this, button)
              })
          })
        })
      }

      handlePrevious (previousButtonElements) {
        previousButtonElements.forEach(button =>
          button.addEventListener('click', () =>
            this.openPreviousAccordion(button)
          )
        )
      }

      initStepFunctions (stepContainers) {
        stepContainers.forEach(stepContainer => {
          const functionNames = stepContainer.dataset.stepFunctions?.split(',')
          functionNames &&
            functionNames.forEach(functionName => {
              if ((functionName === undefined) || (functionName == '')) {
                return
              }
              this.stepFunctions[functionName](this)
            })
          //functions to execute for each specific order summary is provided in the html element itself
        })
      }

      handleDimensionInputs (
        footageSelectElements,
        obstructionDistanceSelectElements,
        mirrorTypeCheckboxes
      ) {
        setTimeout(() => {
          this.setDefaultSelect(footageSelectElements)
        }, 500)
        footageSelectElements.forEach(selectElement => {
          selectElement.addEventListener('change', () => {
            this.setPriceAndVariant(
              footageSelectElements,
              obstructionDistanceSelectElements,
              mirrorTypeCheckboxes
            )
          })
        })
      }

      handleObstructionsInputs (
        footageSelectElements,
        obstructionDistanceSelectElements,
        mirrorTypeCheckboxes
      ) {
        //Timeout is for load after back button
        setTimeout(() => {
          this.setDefaultSelect(obstructionDistanceSelectElements)
        }, 500)
        obstructionDistanceSelectElements.forEach(selectElement => {
          selectElement.addEventListener('change', () => {
            this.setPriceAndVariant(
              footageSelectElements,
              obstructionDistanceSelectElements,
              mirrorTypeCheckboxes
            )
            this.validateSelects(obstructionDistanceSelectElements)
          })
        })
      }

      handleClipAndBevelInputs = clipAndBevelSelectElements => {
        const [
          clipAmountSelectElement,
          bevelStateSelectElement,
          bevelAmountSelect
        ] = clipAndBevelSelectElements
        //Timeout is for load after back button
        setTimeout(() => {
          clipAndBevelSelectElements &&
            this.setDefaultSelect(clipAndBevelSelectElements)
        }, 500)
        clipAndBevelSelectElements.forEach(
          selectElement =>
            selectElement &&
            selectElement.addEventListener('change', () =>
              this.validateSelects(clipAndBevelSelectElements)
            )
        )

        clipAmountSelectElement &&
          clipAmountSelectElement.addEventListener('change', () =>
            this.handleClipSelect(clipAmountSelectElement)
          )

        bevelStateSelectElement &&
          bevelStateSelectElement.addEventListener('change', () =>
            this.handleBevelStateSelect(
              bevelStateSelectElement,
              bevelAmountSelect
            )
          )
      }

      handleMirrorTypeSelect = (
        footageSelectElements,
        obstructionDistanceSelectElements,
        mirrorTypeCheckboxes
      ) => {
        setTimeout(() => {
          this.unselectCheckBoxes(mirrorTypeCheckboxes)
        }, 500)
        mirrorTypeCheckboxes.forEach(checkBox => {
          checkBox.addEventListener('change', () => {
            this.setPriceAndVariant(
              footageSelectElements,
              obstructionDistanceSelectElements,
              mirrorTypeCheckboxes
            )
            const isValid = Array.from(mirrorTypeCheckboxes).some(
              this.validateChecked
            )
            isValid
              ? this.setConditionMet(checkBox)
              : this.setConditionNotMet(checkBox)
          })
        })
      }

      handleOrderSummaryGeneration (accordionContainer) {
        accordionContainer.addEventListener('accordion:opened', () => {
          const orderSummaryItems = this.querySelectorAll(
            '[data-order-summary-item]'
          )
          orderSummaryItems.forEach(orderSummaryItem => {
            const functionName = orderSummaryItem.dataset.sourcingAction
            //functions to execute for each specific order summary is provided in the html element itself
            this.sourcingFunctions[functionName](this, orderSummaryItem)
          })
        })
      }

      handleFormInputsGeneration (accordionContainer) {
        accordionContainer.addEventListener('accordion:opened', () => {
          const form = accordionContainer.querySelector(
            '[data-main-product-form]'
          )
          const productPropertyInputs = form.querySelectorAll(
            '[data-product-property-input]'
          )
          productPropertyInputs.forEach(input => {
            const sourcingFunctionName = input.dataset.inputSourcingAction
            const sourcingFunction = this.inputSourcingFunctions[
              sourcingFunctionName
            ]
            input.value = sourcingFunction(this)
          })
        })
      }

      handleSubmit (productForm, clipForm, handlingFeeForm) {
        productForm.addEventListener('submit', event => {
          event.preventDefault()
          /*const consentCheck = this.querySelector('[data-consent-check]')
          const isValid = this.validateChecked(consentCheck)
            ? this.removeError(consentCheck)
            : this.setError(consentCheck)*/
          const formsToAdd = [handlingFeeForm, clipForm, productForm ].filter(
            this.validateProductFormQuantity
          )
          //isValid && this.addProductsToCart(formsToAdd)
          this.addProductsToCart(formsToAdd)
        })
      }

      //MIDDLEWARE FUNCTIONS
      openNextAccordion (button) {
        const currentAccordion = parseInt(button.dataset.stepIndex)
        const nextAccordion = parseInt(button.dataset.stepIndex) + 1
        this.openAccordion(nextAccordion)
        setTimeout(() => {
          this.closeAccordion(currentAccordion)
        },100)
      }

      openPreviousAccordion (button) {
        const currentAccordion = parseInt(button.dataset.stepIndex)
        const lastAccordion = parseInt(button.dataset.stepIndex) - 1

        this.openAccordion(lastAccordion)
        setTimeout(() => {
          this.closeAccordion(currentAccordion)
        },100)
      }

      getPrice (optionElement) {
        const price = optionElement?.dataset.price
        return price
      }

      getSelectedIndexDataSetValue (select) {
        const decimalValue = parseFloat(
          select.options[select.selectedIndex].dataset.value
        )
        return decimalValue
      }

      setPriceAndVariant (
        footageSelectElements,
        obstructionDistanceSelectElements,
        mirrorTypeCheckboxes
      ) {
        const squareFootage = this.getSquareFootage(
          ...this.calculateFinalWidthAndHeight(
            footageSelectElements,
            obstructionDistanceSelectElements
          )
        )
        const variantSelect = this.querySelector('[data-variant-select]')
        const selectedMirrorType = Array.from(mirrorTypeCheckboxes).find(
          checkbox => checkbox.checked
        )
        const optionElement = this.getVariant(
          variantSelect,
          squareFootage,
          selectedMirrorType
        )
        const price = this.getPrice(optionElement)
        selectElement(variantSelect, optionElement.index)
        this.setPrice(price, this.priceElements)
      }

      widthAndHeightSummary (_this) {
        const width = _this.getTotalMirrorWidth(_this.footageSelectElements)
        const height = _this.getTotalMirrorHeight(_this.footageSelectElements)
        _this.setSummaryWidth(width)
        _this.setSummaryHeight(height)
      }

      obstructionDimensionsSummary (_this) {
        _this.obstructionDistanceSelectElements.forEach(selectElement => {
          _this.setObstructionSummaryAmount(
            selectElement.dataset.axis,
            selectElement.value
          )
        })
      }

      ClipsAndBevelSummary (_this) {
        const [
          clipAmountSelect,
          isBeveledSelect,
          beveledAmountSelect
        ] = _this.clipAndBevelSelectElements

        _this.setClipAmountSummary(clipAmountSelect.value)
        _this.setClipSummary(clipAmountSelect.value)
        _this.setIsBeveledSummary(isBeveledSelect.value)
        _this.setBevelAmountSummary(beveledAmountSelect.value)
      }

      outerWidthAndHeightSummary (_this) {
        const [outerWidth, outerHeight] = _this.calculateFinalWidthAndHeight(
          _this.footageSelectElements,
          _this.obstructionDistanceSelectElements
        )
        _this.setOuterWidthSummary(outerWidth)
        _this.setOuterHeightSummary(outerHeight)
      }

      productVariantSummary (_this) {
        const framedMirrorVariant = _this.querySelector(
          '[name="frameType"]:checked'
        )
        const value = framedMirrorVariant?.value
        _this.setProductVariantSummary(value)
      }

      handleClipSelect (selectElement) {
        const clipAmount = parseInt(selectElement.value)
        //Since in javascript 0 is falsy on JS, need to check gainst NAN
        clipAmount !== NaN && this.addClipAmount(clipAmount)
      }

      handleBevelStateSelect (bevelStateSelectElement, bevelAmountSelect) {
        const functionName = bevelStateSelectElement?.dataset?.inputAction
        const nextStepButton = bevelStateSelectElement?.closest('[data-accordion]')?.querySelector('.accordion__body_controls_next-btn')
        const stopOrContinue = functionName ? this.inputFunctions[functionName](bevelStateSelectElement, this) : 'continue'
        if ( stopOrContinue.text === 'stop' )  {
          stopOrContinue.callback(nextStepButton, this)
          return
        } else if (stopOrContinue.text === 'continue') {
          stopOrContinue.callback(nextStepButton, this)
        }
        bevelStateSelectElement.value.toLowerCase() === 'yes'
          ? this.showBevelAmountSelect(bevelAmountSelect)
          : this.hideBevelAmountSelect(bevelAmountSelect)
      }

     async addProductsToCart (forms) {
        // Check if a handling fee is already in the cart
        const cart = await (await fetch('/cart.js')).json()
        const handlingFeeExists = cart.items.some(
          item => item.handle?.includes('handling-fee')
        )

        // If a fee exists, don't add another one
        const formsToProcess = handlingFeeExists
          ? forms.filter(form => !form.hasAttribute('handling-fee-form'))
          : forms

        // Generate a unique link ID to connect parent product with its handling fee and clips
        const linkId = generateProductLinkId()
        
        // Map forms to their data with the link ID
        const formsData = formsToProcess.map(form => {
          const isMainProductForm = form.hasAttribute('data-main-product-form');
          const isClipForm = form.hasAttribute('data-clip-form');
          const isHandlingFeeForm = form.hasAttribute('handling-fee-form');
      
          // Main product gets linkId; only mark as oversized if handling fee is needed
          if (isMainProductForm) {
            const isOversized = forms.some(f =>
              f.hasAttribute('handling-fee-form') &&
              parseInt(f.querySelector('[name="quantity"]')?.value) > 0
            )
            return getDataFromForm(form, linkId, isOversized);
          }
      
          // Clips get the linkId
          if (isClipForm) {
              return getDataFromForm(form, linkId);
          }
      
          // Handling fee should NOT get a linkId
          if (isHandlingFeeForm) {
              return getDataFromForm(form); // No linkId
          }
      
          // Fallback for any other form
          return getDataFromForm(form);
        })
        
        try {
          await addMultipleToCart(formsData)
          window.location.href = '/cart'
        } catch {
          alert('error, please reload the page and try again')
        }
      } 

      //stepFunctions
      handlingFeeNotNeededFunctions (_this, stepContainer, nextStepButton) {
        _this.setHandlingFeeFalse()
        _this.defaultNextStepFunctions(nextStepButton, _this)
        stepContainer.dataset.oneTimeAlertViewed = "false"
      }

      checkForFrameMyMirrorHandlingFees(_this) {
        const footageSelectElements = _this.footageSelectElements
        footageSelectElements.forEach(selectElement => {
          selectElement.addEventListener('change', () => {
            const stepContainer = selectElement?.closest('[data-accordion]')
            const nextStepButton = stepContainer?.querySelector('.accordion__body_controls_next-btn')
            const needsFees = _this.validatFrameMyMirrorHandlingFees(footageSelectElements)
            needsFees ?
              _this.frameMyMirrorhandlingFeeFunctions(nextStepButton, _this):
              _this.handlingFeeNotNeededFunctions(_this, stepContainer, nextStepButton)
            
          })
        })
      }

      checkForFramedMirrorHandlingFees(_this) {
        const footageSelectElements = _this.footageSelectElements
        footageSelectElements.forEach(selectElement => {
          selectElement.addEventListener('change', () => {
            const stepContainer = selectElement?.closest('[data-accordion]')
            const nextStepButton = stepContainer?.querySelector('.accordion__body_controls_next-btn')
            const needsFees = _this.validateFramedMirrorHandlingFees(footageSelectElements)
            needsFees ?
              _this.framedMirrorhandlingFeeFunctions(nextStepButton, _this):
              _this.handlingFeeNotNeededFunctions(_this, stepContainer, nextStepButton)

          })
        })
      }

      checkForFramedMirrorLengthImbalance (_this) {
        const footageSelectElements = _this.footageSelectElements
        const lengthBalanceCutoff = 48
        const moreThanCutOff = moreThan(lengthBalanceCutoff)
        const widthElement = footageSelectElements[0]
        const heightElement = footageSelectElements[2]

        const heightOptionsToDisable = Array.from(heightElement.options).filter(
          option => moreThanCutOff(parseInt(option.value))
        )

        const widthOptionsToDisable = Array.from(widthElement.options).filter(
          option => moreThanCutOff(parseInt(option.value))
        )

        footageSelectElements.forEach(selectElement => {
          selectElement.addEventListener('change', () => {
            const widthValue = parseInt(widthElement.value)
            const heightValue = parseInt(heightElement.value)

            widthValue > lengthBalanceCutoff
              ? heightOptionsToDisable.map(_this.disableElement)
              : heightOptionsToDisable.map(_this.enableElement)

            heightValue > lengthBalanceCutoff
              ? widthOptionsToDisable.map(_this.disableElement)
              : widthOptionsToDisable.map(_this.enableElement)
          })
        })
      }

      //inputFunctions
      disableBevelStateSelect (bevelStateSelectElement, _this) {
        if (bevelStateSelectElement.options[bevelStateSelectElement.selectedIndex].value?.toLowerCase() === 'yes' ) {
          return  {
            text: 'stop',
            callback: _this.narrowFrameFunctions
          }
        } else {
          return {
            text: 'continue',
            callback: _this.defaultNextStepFunctions
          }
        }
      }

      //GETTERS
      getWidthInputValue (_this) {
        const width = `${_this.getTotalMirrorWidth(
          _this.footageSelectElements
        )}`
        return width
      }
      getHeightInputValue (_this) {
        const height = `${_this.getTotalMirrorHeight(
          _this.footageSelectElements
        )}`
        return height
      }
      getTopInputValue (_this) {
        const top =
          _this.querySelector('[ data-obstruction-top-select ]').value || 'N/A'
        return top
      }
      getRightInputValue (_this) {
        const right =
          _this.querySelector('[ data-obstruction-right-select ]').value ||
          'N/A'
        return right
      }
      getBottomInputValue (_this) {
        const bottom =
          _this.querySelector('[ data-obstruction-bottom-select ]').value ||
          'N/A'
        return bottom
      }
      getLeftInputValue (_this) {
        const left =
          _this.querySelector('[ data-obstruction-left-select ]').value || 'N/A'
        return left
      }
      getFrameWidthInputValue (_this) {
        const outerWidth =
          _this.calculateFinalWidthAndHeight(
            _this.footageSelectElements,
            _this.obstructionDistanceSelectElements
          )[0] || 'N/A'
        return outerWidth
      }
      getFrameHeighthInputValue (_this) {
        const outerHeight =
          _this.calculateFinalWidthAndHeight(
            _this.footageSelectElements,
            _this.obstructionDistanceSelectElements
          )[1] || 'N/A'
        return outerHeight
      }
      getBevelStateInputValue (_this) {
        const bevelState = _this.querySelector('[data-is-beveled-select]').value
        return bevelState
      }
      getBevelWidthInputValue (_this) {
        const bevelState = _this.querySelector('[data-bevel-amount-select]')
          .value
        return bevelState
      }
      
        // Additional function to get hangrail value based on height
  getHangRailValueBasedOnHeight(height) {
    const hangRailRanges = Object.entries(this.hangRailHeightValues);
    const matchingHangRailArray = hangRailRanges.filter(arr => {
      const subArray = arr[1];
      const numberRange = rangeFrom(subArray[0], subArray[1]);
      const result = numberRange.some(value => value === height);
      return result;
    })[0];
    return matchingHangRailArray ? matchingHangRailArray[0] : '';
  }

      getCustomSku (_this) {
        const customSkuSelect = _this.querySelector('[data-base-sku]')
        const baseSku = customSkuSelect.dataset.baseSku
        const squareFootage = _this.getSquareFootage(
          ..._this.calculateFinalWidthAndHeight(
            _this.footageSelectElements,
            _this.obstructionDistanceSelectElements
          )
        )
        const linearFootageRanges = Object.entries(_this.linearFootageRanges)
    const width = parseInt(_this.footageSelectElements[0].value);
    const height = parseInt(_this.footageSelectElements[2].value);
        const hangRailRanges = Object.entries(_this.hangRailValues)
        const selectedMirrorTypeValue = Array.from(
          _this.mirrorTypeCheckboxes
        ).find(checkbox => checkbox.checked)?.value

        // Get the linear footage range based off the inputted linear footage
        const variablesMatch = a => b => a == b
        const listedValueMatchesInputted = squareFootage =>
          variablesMatch(squareFootage)

        const matchingFootageArray = linearFootageRanges.filter(arr =>
          arr[1].some(listedValueMatchesInputted(squareFootage))
        )[0]
        const linearFootageRange = matchingFootageArray[0]

        //Get Hangrail value based off width range
        const matchingHangRailArray = hangRailRanges.filter(arr => {
          const subArray = arr[1]
          const numberRange = rangeFrom(subArray[0], subArray[1])
          const result = numberRange.some(listedValueMatchesInputted(width))
          return result
        })[0]
        const hangRail =
          _this.frameType === 'framedMirror' ? matchingHangRailArray[0] : ''
    // Get Hangrail value based on height
    const hangRailHeight =
      _this.frameType === 'framedMirror' ? _this.getHangRailValueBasedOnHeight(height) : '';

        //Get short-code for mirror type
        const mirrorType = _this.mirrorTypeValues[selectedMirrorTypeValue]
        console.log(
          _this.generateSku(baseSku, linearFootageRange, hangRail, hangRailHeight, mirrorType)
        )
        return _this.generateSku(
          baseSku,
          linearFootageRange,
          hangRail,
          hangRailHeight,
          mirrorType
        )
      }

      getVariant (variantSelect, squareFootage, mirrorTypeElement) {
        const mirrorType = mirrorTypeElement?.value

        //Check if the variant select is formatted to match framed the setup for framed mirror, and find matching linear footage with variant
        const matchingMirrorTypeOptions = mirrorType
          ? variantSelect.querySelectorAll(`[data-mirror-type="${mirrorType}"]`)
          : variantSelect.querySelectorAll(`[data-mirror-type="Standard"]`)
        const matchingMirrorTypeOption = Array.from(
          matchingMirrorTypeOptions
        ).find(option => parseInt(option.dataset?.value) == squareFootage)

        //If a variant with linear footage and with mirror type was found, use that variant, if not, find variant with just linear footage
        const optionElement = matchingMirrorTypeOption
          ? matchingMirrorTypeOption
          : variantSelect.querySelector(`[data-value="${squareFootage}"]`)

        return optionElement
      }

      getActiveStatus (el) {
        if (el.classList?.classList?.length === 0 ) return
        return Array.from(el.classList).join().includes('active')
      }

      validateChecked (checkboxInput) {
        return checkboxInput.checked
      }

      validateProductFormQuantity (form) {
        const quantityInput = form.querySelector('[name="quantity"]')
        const quantity = parseInt(quantityInput.value)
        return quantity > 0
      }

      narrowFrameFunctions (button, _this)  {
        _this.triggerNarrowFrameModal()
        _this.setNextStepAction(button,'validateNarrowFrame')
        _this.setConditionNotMetAlert(button, 'triggerNarrowFrameModal')
      }

      frameMyMirrorhandlingFeeFunctions (button, _this) {
        _this.setHandlingFeeTrue()
        _this.setNextStepAction(button,'validateOneTimePopup')
        _this.setConditionNotMetAlert(button, 'triggerFrameMyMirrorHandlingFeesModal')
      }

      framedMirrorhandlingFeeFunctions (button, _this) {
        _this.setHandlingFeeTrue()
        _this.setNextStepAction(button,'validateOneTimePopup')
        _this.setConditionNotMetAlert(button, 'triggerFramedMirrorHandlingFeesModal')
      }

      defaultNextStepFunctions (button, _this) {
        _this.setNextStepAction(button ,'validateStep')
        _this.setConditionNotMetAlert(button , 'triggerIncompleteInputAlert')
      }

      //DOM CHANGES
      setPrice (price, priceElements) {
        priceElements.forEach(
          priceElement => (priceElement.textContent = price.toString())
        )
      }

      openAccordion (index) {
        const accordionContainer = this.querySelector(
          `[data-accordion="${index}"]`
        )
        if(  accordionContainer == null ||  accordionContainer == undefined) {
          return
        }
        const accordionHeader = accordionContainer.querySelector(
          '.accordion_header'
        )

        addClass(accordionContainer, 'accordion--active')
        setTimeout( () => {
          if (window.innerWidth > 900)  window.scrollTo({ top: accordionHeader.offsetTop, behavior: 'smooth'});   
        },1500)

        accordionContainer.dispatchEvent(
          new CustomEvent('accordion:opened', { bubbles: true })
        )
      }

      closeAccordion (index) {
        const accordionContainer = this.querySelector(
          `[data-accordion="${index}"]`
        )
        if(  accordionContainer == null ||  accordionContainer == undefined) {
          return
        }
        removeClass(accordionContainer, 'accordion--active')
      }

      setConditionMet (element) {
        const accordionContainer = element.closest('[data-condition-met]')
        accordionContainer.dataset.conditionMet = 'true'
      }

      setConditionNotMet (element) {
        const accordionContainer = element.closest('[data-condition-met]')
        accordionContainer.dataset.conditionMet = 'false'
      }

      setSummaryWidth (width) {
        const widthTextSummaryElements = this.querySelectorAll(
          '[data-summary-width]'
        )
        widthTextSummaryElements.forEach(
          widthTextSummaryElement => (widthTextSummaryElement.innerText = width)
        )
      }

      setSummaryHeight (height) {
        const heightTextElements = this.querySelectorAll(
          '[data-summary-height]'
        )
        heightTextElements.forEach(
          heightTextElement => (heightTextElement.innerText = height)
        )
      }

      setObstructionSummaryAmount = (axis, amount) => {
        const obstructionSummaryElement = this.querySelector(
          `[data-summary-obstruction-${axis}]`
        )
        obstructionSummaryElement.innerText = amount
      }

      setClipAmountSummary = amount => {
        const clipAmountSummaryElements = this.querySelectorAll(
          '[data-clip-amount-summary]'
        )

        clipAmountSummaryElements.forEach(
          clipAmountSummaryElement =>
            (clipAmountSummaryElement.innerText = amount)
        )
      }

      setClipSummary (amount) {
        const clipSummaryElement = this.querySelector('[data-clip-summary ]')
        const amountInt = parseInt(amount)
        if (amountInt === NaN) {
          return
        }
        if (amountInt > 0) {
          clipSummaryElement.dataset.hasClip = 'true'
        } else {
          clipSummaryElement.dataset.hasClip = 'false'
        }
      }

      setIsBeveledSummary = trueOrFalse => {
        const isBeveledSummary = this.querySelector('[data-is-beveled-summary]')
        isBeveledSummary.innerText = trueOrFalse
      }

      setBevelAmountSummary = amount => {
        const bevelAmountSummaryElement = this.querySelector(
          '[data-bevel-amount-summary]'
        )
        bevelAmountSummaryElement.innerText = amount
      }

      setOuterWidthSummary (amount) {
        const outerWidthSummaryElement = this.querySelector(
          '[data-summary-outer-width]'
        )
        outerWidthSummaryElement.innerText = amount
      }

      setOuterHeightSummary (amount) {
        const outerHeightSummaryElement = this.querySelector(
          '[data-summary-outer-height]'
        )
        outerHeightSummaryElement.innerText = amount
      }

      setProductVariantSummary (value) {
        const productVariantSummaryElement = this.querySelector(
          '[data-variant-summary]'
        )
        productVariantSummaryElement.innerText = value
      }

      setHandlingFeeTrue () {
        const handlingFeeForm = this.querySelector('[handling-fee-form]')
        const handlingFeeQuantity = this.querySelector(
          '[data-handling-fee-quantity]'
        )
        this.orderSummaryContainerElement.dataset.hasHandlingFee = 'true'
        handlingFeeQuantity.value = 1
        handlingFeeForm.dataset.hasHandlingFee = 'true'
      }

      setHandlingFeeFalse () {
        const handlingFeeForm = this.querySelector('[handling-fee-form]')
        const handlingFeeQuantity = this.querySelector(
          '[data-handling-fee-quantity]'
        )
        this.orderSummaryContainerElement.dataset.hasHandlingFee = 'false'
        handlingFeeQuantity.value = 0
        handlingFeeForm.dataset.hasHandlingFee = 'false'
      }

      addClipAmount (amount) {
        const clipQuantityInput = this.querySelector('[data-clip-amount]')
        clipQuantityInput.value = amount
      }

      showBevelAmountSelect (bevelAmountSelect) {
        bevelAmountSelect.parentNode.style.display = 'block'
      }

      hideBevelAmountSelect (bevelAmountSelect) {
        bevelAmountSelect.value = 'N/A'
        bevelAmountSelect.parentNode.style.display = 'none'
      }

      setError (input) {
        const inputContainer = input.parentNode
        addClass(inputContainer, 'error')
        return false
      }

      removeError (input) {
        const inputContainer = input.parentNode
        removeClass(inputContainer, 'error')
        return true
      }

      setDefaultSelect (selectElements) {
        selectElements.forEach(
          select => (select.value = select.options[0].value)
        )
      }

      unselectCheckBoxes (checkBoxes) {
        checkBoxes.forEach(checkbox => {
          checkbox.checked = false
        })
      }

      disableElement (element) {
        element.disabled = true
      }

      enableElement (element) {
        element.disabled = false
      }

      setNextStepAction (el, string) {
        el.dataset.nextStepActions = string
      }

      setConditionNotMetAlert (el, string) {
        el.dataset.conditionNotMetAlert = string
      }

      //CALCULATION
      generateSku (baseSku, linearFootageRange, hangRail, hangRailHeight, mirrorType) {
        return `${baseSku || ''} ${linearFootageRange || ''} ${hangRail ||
          ''} ${hangRailHeight || ''} ${mirrorType || ''}`
      }

      calculateFinalWidthAndHeight (
        footageSelectElements,
        obstructionDistanceSelectElements
      ) {
        const [
          topObstruction,
          rightObstruction,
          bottomObstruction,
          leftObstruction
        ] = Array.from(obstructionDistanceSelectElements).map(
          this.getSelectedIndexDataSetValue
        )

        const width = this.getTotalMirrorWidth(footageSelectElements)
        const height = this.getTotalMirrorHeight(footageSelectElements)
        const min = 0.375

        const outerHeight =
          height +
          this.ifMeetsMinReturnMin(bottomObstruction, min) +
          this.ifMeetsMinReturnMin(topObstruction, min)

        const outerWidth =
          width +
          this.ifMeetsMinReturnMin(rightObstruction, min) +
          this.ifMeetsMinReturnMin(leftObstruction, min)

        return [outerWidth, outerHeight]
      }

      ifMeetsMinReturnMin (value, min) {
        if (value === undefined) {
          return 0
        }
        return value >= min ? 0.375 : 0
      }

      getSquareFootage (width, height) {
        const totalSquareFootage = Math.ceil((width + height) / 6)
        return totalSquareFootage
      }

      getTotalMirrorWidth (footageSelectElements) {
        const width = parseInt(footageSelectElements[0].value)
        const fractionalWidth = parseFloat(footageSelectElements[1].value)
        return width + fractionalWidth
      }

      getTotalMirrorHeight (footageSelectElements) {
        const height = parseInt(footageSelectElements[2].value)
        const fractionalHeight = parseFloat(footageSelectElements[3].value)
        return height + fractionalHeight
      }

      //VALIDATIONS
      validateSelects (selectElements) {
        const firstSelectElement = selectElements[0]
        const isValid = Array.from(selectElements).every(
          selectElement => selectElement.value !== ''
        )
        isValid
          ? this.setConditionMet(firstSelectElement)
          : this.setConditionNotMet(firstSelectElement)
      }

      // validateFunctions
      validateStep (buttonElement) {
        const stepContainer = buttonElement.closest('[data-accordion]')
        return stringFalseOrTrue(stepContainer.dataset.conditionMet)
      }

      validateNarrowFrame (button) {
        const stepContainer = button.closest('[data-accordion]')
        const bevelSelect = stepContainer?.querySelector('[data-is-beveled-select]')
        if (bevelSelect.selectedOptions[0].value.toLowerCase() === 'yes') {
          return false
        } else {
          return true
        }
      }

      validateOneTimePopup (button) {
        const stepContainer = button?.closest('[data-accordion]')
        const modalOpened = stepContainer?.dataset?.oneTimeAlertViewed
        if( modalOpened === 'true') {
          return true
        } else {
          return false
        }
      }

      validateFramedMirrorHandlingFees (footageSelectElements) {
        const widthAndHeight = [
          footageSelectElements[0],
          footageSelectElements[2]
        ]
        const handlingFeeMin = parseInt(
          footageSelectElements[0].dataset.handlingFeeMinSize
        )

        const totalCombinedInches = widthAndHeight.reduce(
          (selectElement, selectElementB) =>
            parseInt(selectElement.value) + parseInt(selectElementB.value)
        )
        const needsFees = totalCombinedInches > handlingFeeMin

        return needsFees
      }

      validatFrameMyMirrorHandlingFees(footageSelectElements) {
        const widthAndHeight = [
          footageSelectElements[0],
          footageSelectElements[2]
        ]
        const handlingFeeMin = parseInt(
          footageSelectElements[0].dataset.handlingFeeMinSize
        )
        const needsFees = widthAndHeight.some(
          selectElements => parseInt(selectElements.value) > handlingFeeMin
        )
        return needsFees 
      }

      //Alerts

      //alertFunctions
      triggerIncompleteInputAlert (_this) {
        alert(_this.incompleteFieldsText)
      }

      triggerNarrowFrameModal () {
        const modalElement = document.getElementById('narrow-frame-modal');
        if (!modalElement) {
          console.error('Modal not found: narrow-frame-modal');
          return;
        }
        MicroModal.show('narrow-frame-modal');
      }

      triggerFrameMyMirrorHandlingFeesModal (_this, button) {
        const stepContainer = button.closest('[data-accordion]')
        const modalElement = document.getElementById('handling-fee-modal');
        if (!modalElement) {
          console.error('Modal not found: handling-fee-modal');
          return;
        }
        MicroModal.show('handling-fee-modal')
        stepContainer.dataset.oneTimeAlertViewed = "true"
      }

      triggerFramedMirrorHandlingFeesModal (_this, button) {
        const stepContainer = button.closest('[data-accordion]')
        MicroModal.show('framed-mirror-handling-fee-modal')
        stepContainer.dataset.oneTimeAlertViewed = "true"
      }

    }
  )
}

if (!customElements.get('sample-button')) {
  customElements.define(
    'sample-button',
    class ProductForm extends HTMLElement {
      constructor () {
        super()
        this.form = this.querySelector('form')
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.id = parseInt(this.querySelector('[name="id"]').value, 0)
        this.submitButton = this.form.querySelector('[role="submit"]')
        this.formData = {
          items: [
            {
              id: this.id,
              quantity: 1
            }
          ],
          sections: 'custom-cart-drawer'
        }
      }
      onSubmitHandler (evt) {
        evt.preventDefault()

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.formData)
        })
          .then(response => {
            return response.json()
          })
          .then(data => {
            //variables
            const item = data.items[0]
            const itemWithSection = {...item, sections: data.sections}

            //functions
            theme.removeAddedCartDrawer();
            theme.addedToCartHandler.bind(this.form)(itemWithSection)
            tempDisable(this.submitButton, 1000)
          })
      }
    }
  )
}
